import React from "react";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import { SiCodewars } from "react-icons/si";

const HeaderSocials = () => {
    return (
        <div className="header__socials">
            <a
                href="https://www.linkedin.com/in/dmitry-sinyavskiy/"
                target="_blank"
            >
                <BsLinkedin />
            </a>
            <a href="https://github.com/uch2ha" target="_blank">
                <BsGithub />
            </a>
            <a href="https://www.codewars.com/users/uch2ha" target="_blank">
                <SiCodewars />
            </a>
        </div>
    );
};

export default HeaderSocials;
